<template>
  <div class="view your" data-name="your">
    <RailsContent :data="instagram" :is-medium="false" />
    <PageHero :title="'Social.'" :text="''" />
  </div>
</template>

<script>
import PageHero from '@/components/heros/PageHero.vue';
import RailsContent from '@/components/contents/RailsContent.vue';
import demetra from '../scripts/demetra';

export default {
  name: 'your',

  components: {
    PageHero,
    RailsContent,
  },

  data() {
    return {
      instagram: [],
    };
  },

  mounted() {
    demetra.ref.fetchArchive('instagram').then((response) => {
      const insta = new Map();
      response.archive.items.forEach((i) => {
        insta.set(i.title, i.structure);
      });

      this.instagram = [...insta.values()];
    });
  },
};
</script>
